import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization, getLoggedinUser } from "../utils/api_helper_custom";
import { useDispatch } from "react-redux";

import { useProfile } from "../utils/UserHooks";

import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const { userProfile, loading, tokenbool, authToken } = useProfile();
  const token = authToken;
  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */

  if (!userProfile && loading && !token) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return <>{props.children}</>;
};

// Role-based protected route component
const RoleProtected = ({ children, allowedRoles = [] }) => {
  const currentUser = getLoggedinUser();
  
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  const userRole = currentUser.role || currentUser.user_type;
  
  if (!allowedRoles.includes(userRole)) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="card">
                <div className="card-body text-center">
                  <div className="mb-4">
                    <i className="ri-error-warning-line text-danger" style={{ fontSize: '4rem' }}></i>
                  </div>
                  <h4 className="text-danger">Access Denied</h4>
                  <p className="text-muted">
                    You don't have permission to access this page. 
                    This page is restricted to: {allowedRoles.join(', ')}.
                  </p>
                  <button 
                    className="btn btn-primary" 
                    onClick={() => window.history.back()}
                  >
                    Go Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return <>{children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute, RoleProtected };